<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-download-desktop`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M43 6a2 2 0 012 2v27a2 2 0 01-2 2H26v2.999L33 40a1 1 0 011 1v2a1 1 0 01-1 1l-7-.001V44h-4v-.001L15 44a1 1 0 01-1-1v-2a1 1 0 011-1l7-.001V37H5a2 2 0 01-2-2V8a2 2 0 012-2h38zm-2 4H7v23h34V10zm-15.945 4a1 1 0 011 1v5.846h3.795a1 1 0 01.735 1.679l-5.59 6.046a1.058 1.058 0 01-1.423.262 1.002 1.002 0 01-.262-.243l-5.844-6.05a1 1 0 01.72-1.694h3.768V15a1 1 0 011-1h2.1z"/></svg>
</template>
<script>

export default {
  name: 'IconDownloadDesktop',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
